"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthType = void 0;
const device_1 = require("@completeanatomy/device");
function useAuthType() {
    const isCNRegion = (0, device_1.useIsCNRegion)();
    return isCNRegion ? 'sso' : 'neoId';
}
exports.useAuthType = useAuthType;
